import React from 'react'
import ReactOnRails from 'react-on-rails'
import { connect } from 'react-redux'

export default (...args) => (WrappedComponent) => {
  const ConnectedWrappedComponent = connect(...args)(WrappedComponent)
  return function (props) {
    const store = ReactOnRails.getStore('appStore')
    return <ConnectedWrappedComponent {...props} store={store} />
  }
}



// WEBPACK FOOTER //
// app/javascript/src/utils/connect.js